import { AfterViewInit, Component, Inject, Input, NgZone, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-route-modal',
  templateUrl: './route-modal.component.html',
  styleUrls: ['./route-modal.component.css']
})
export class RouteModalComponent implements OnInit,AfterViewInit{
  injectedData: any;
  taskStatusForm: FormGroup;
  someObject: any = {'vivek':'mahajan'};
  selectedTaskStatus: string = '';
  startLat:any;
  startLon:any;
  endLat:any;
  endLon:any;

  private map: google.maps.Map | undefined;
  constructor(public dialogRef: MatDialogRef<RouteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private commonService:CommonService, private ngZone: NgZone) {
      this.injectedData = data;
     }
  ngAfterViewInit() {
    this.ngZone.runOutsideAngular(() => {
      this.calculateAndDisplayRoute(this.directionsService, this.directionsRenderer, 0);
    });
  }
directionsService = new google.maps.DirectionsService();
directionsRenderer = new google.maps.DirectionsRenderer();
  ngOnInit(): void {
    this.startLat=this.injectedData.startlatitudelocation
    this.startLon=this.injectedData.startlongitudelocation
    this.endLat =this.injectedData.endlatitudelocation
    this.endLon =this.injectedData.endlongitudelocation
    const origin = `${this.startLat},${this.startLon}`;
    const destination = `${this.endLat},${this.endLon}`;
    const startLat = this.injectedData.startlatitudelocation;
    const startLon = this.injectedData.startlongitudelocation;
    const endLat = this.injectedData.endlatitudelocation;
    const endLon = this.injectedData.endlongitudelocation; 
  }
  // initMap(startLat: number, startLon: number, endLat: number, endLon: number): void {
  //   const origin = new google.maps.LatLng(startLat, startLon);
  //   const destination = new google.maps.LatLng(endLat, endLon);

  //   this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
  //     zoom: 10,
  //     center: origin
  //   });

  //   // Draw the route
  //   this.commonService.getDirections1('AIzaSyCyxa0d5VJiM4MCBrdLrSCa_CRA0TTYhpA', `${startLat},${startLon}`, `${endLat},${endLon}`)
  //     .subscribe(
  //       response => {
  //         const directionsRenderer = new google.maps.DirectionsRenderer();
  //         directionsRenderer.setMap(this.map as google.maps.Map);
  //         directionsRenderer.setDirections(response);
  //       },
  //       error => {
  //         console.error('Error getting directions:', error);
  //       }
  //     );
  // }

  

  closeModal(): void {
    this.dialogRef.close();
  }
  calculateAndDisplayRoute(
    directionsService: any,
    directionsRenderer: any,
    index: any
  ){

    const origin = new google.maps.LatLng(this.startLat, this.startLon);
  const destination = new google.maps.LatLng(this.endLat, this.endLon);
    directionsService.route({
      origin: `${this.startLat},${this.startLon}`,
      destination:`${this.endLat},${this.endLon}` ,
      optimizeWaypoints: true,
      travelMode: google.maps.TravelMode.DRIVING,
    })
    .then((response: google.maps.DirectionsResult) => {
      directionsRenderer.setDirections(response);
      const map = new google.maps.Map(document.getElementById('map'), {
        center: { lat:18.565161, lng: 73.912547 },
        zoom: 11,
      });

        // Add marker at the origin
    // new google.maps.Marker({
    //   position: origin,
    //   map: map,
    //   title: 'Origin',
    //   icon: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png', // Custom marker icon
    // });

    // // Add marker at the destination
    // new google.maps.Marker({
    //   position: destination,
    //   map: map,
    //   title: 'Destination',
    //   icon: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png', // Custom marker icon
    // });
      // const routePolyline = new google.maps.Polyline({
      //   path: response.routes[0].overview_path,
      //   geodesic: true,
      //   strokeColor: '#FF0000',
      //   strokeOpacity: 1.0,
      //   strokeWeight: 2,
      // });
      

      // routePolyline.setMap(map);
      directionsRenderer.setMap(map);
    })
    .catch((e: any) => console.log('Directions request failed due to ' + e));
}



// declare global {
//   interface Window {
//     initMap: () => void;
//   }
// }
// window.initMap = initMap;


}





